if (!customElements.get('shipping-benefits-section')) {
  class ShippingBenefitsSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = this.closest('.section-shipping-benefits');
      if (!this.section) return;
    }
  }

  customElements.define('shipping-benefits-section', ShippingBenefitsSection);
}
